<!-- Loading bar -->
<app-loading-bar-onpush></app-loading-bar-onpush>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full">
    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <router-outlet></router-outlet>
    </div>
</div>
